import {HTTP} from "../_helpers/http";
import {config} from "@shared/_services/config";

export default class UserResourcesApi {

    static _handleError(error) {
        if (error.response) {
            throw {
                messages: error.messages
            };
        }
    }

    static fetchAll() {

        return HTTP.get(config.userApi.resource)
            .then(response => response.data)
            .catch(error => {
                this._handleError(error);
            })
    }

    static save(resource) {
        return HTTP.post(`/resource`, resource)
            .then(response => response.data)
    }

    static update(id, resource) {
        return HTTP.put(`/resource/${id}`, resource)
            .then(response => response.data)
    }

    static delete(id) {
        return HTTP.delete(`/resource/${id}`)
            .then(response => response.data)
    }
}